var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#EEFFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3229 16.478C23.3229 15.6617 23.9846 15 24.8009 15H38.6417C39.0535 15 39.4468 15.1719 39.7265 15.4742L44.6069 20.7486C44.8596 21.0218 45 21.3803 45 21.7524V43.0817C45 43.898 44.3383 44.5597 43.522 44.5597H24.8009C23.9846 44.5597 23.3229 43.898 23.3229 43.0817V16.478ZM28.7422 24.8532C28.4701 24.8532 28.2495 25.0738 28.2495 25.3459C28.2495 25.618 28.4701 25.8386 28.7422 25.8386H39.0881C39.3602 25.8386 39.5807 25.618 39.5807 25.3459C39.5807 25.0738 39.3602 24.8532 39.0881 24.8532H28.7422ZM28.2495 29.2872C28.2495 29.0151 28.4701 28.7945 28.7422 28.7945H39.0881C39.3602 28.7945 39.5807 29.0151 39.5807 29.2872C39.5807 29.5593 39.3602 29.7799 39.0881 29.7799H28.7422C28.4701 29.7799 28.2495 29.5593 28.2495 29.2872ZM28.7422 32.7358C28.4701 32.7358 28.2495 32.9564 28.2495 33.2285C28.2495 33.5006 28.4701 33.7212 28.7422 33.7212H39.0881C39.3602 33.7212 39.5807 33.5006 39.5807 33.2285C39.5807 32.9564 39.3602 32.7358 39.0881 32.7358H28.7422ZM15.7124 22.1749L22.3376 18.2592V22.1021L17.1839 27.3879L15.2141 24.2048C14.7911 23.5066 15.0143 22.5978 15.7124 22.1749ZM22.3376 23.5135L15.7754 30.244C15.2056 30.8285 15.2174 31.7643 15.8019 32.3341L22.3376 39.029V23.5135Z",
    fill: "#169D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/frame4.a676ae3453fd2aaa52b0a6e6502534f1.svg";
export { ForwardRef as ReactComponent };